export default __webpack_public_path__ + "static/media/table.516a97a3.png";